import { TmsContextType } from '@awazevr/mfe-common.contexts.tms'
import {
  DataLayerEventType,
  DataLayerFactory,
} from '@awazevr/mfe-common.contexts.tms'

import { dataLayerErrorHandler } from '@/utils/dataLayerErrorHandler'

interface FireFacetClearAllEventProps {
  tms: TmsContextType
}

export const fireFacetClearAllEvent = ({
  tms,
}: FireFacetClearAllEventProps): void => {
  new DataLayerFactory()
    .getEvent(DataLayerEventType.FacetClearAll)
    .update(tms, {}, dataLayerErrorHandler)
}
